var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:_vm.badgeClass},[_vm._v(_vm._s(_vm.textStatus)),(_vm.foc && _vm.status == 'porting')?_c('span',[_vm._v(" (FOC: "+_vm._s(_vm.foc)+")")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }